import i18n from "@/plugins/i18n";

export const journalContentTabs = {
    group: {
        label: i18n.t("tabs.group"),
        id: "group",
        icon: "mdi-shape-plus",
    },
    paper_edit: {
        label: i18n.t("tabs.paper_edit"),
        id: "paper_edit",
        icon: "mdi-file-document-edit",
    },
    index: {
        label: i18n.t("tabs.index"),
        id: "index",
        icon: "mdi-format-list-numbered",
    },
    final_check: {
        label: i18n.t("tabs.final_check"),
        id: "final_check",
        icon: "mdi-eye",
    },
    page: {
        label: i18n.t("tabs.page"),
        id: "page",
        icon: "mdi-pencil",
    },
    page_v2: {
        label: "페이지 편집 v2",
        id: "page_v2",
        icon: "mdi-pencil-box",
    },
    backcover: {
        label: "Back Cover",
        id: "backcover",
        icon: "mdi-book-open-variant",
    },
};

export const selectContentTypeOptions = [
    {
        idx: 1,
        text: i18n.t("label.info_page"),
        code: "info",
    },
    {
        idx: 2,
        text: i18n.t("label.body_page"),
        code: "body",
    },
    {
        idx: 3,
        text: i18n.t("label.empty_page"),
        code: "empty",
    },
];